var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElektrabergzDetailsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 29C25.866 29 29 25.866 29 22C29 18.134 25.866 15 22 15C18.134 15 15 18.134 15 22C15 25.866 18.134 29 22 29Z",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 30.9999L26.9495 26.9492",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14H13",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19H10",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24H10",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 31H3C2.46956 31 1.96086 30.7892 1.58579 30.4142C1.21071 30.0391 1 29.5304 1 29V7.99999C1 7.46956 1.21071 6.96085 1.58579 6.58578C1.96086 6.21071 2.46956 5.99999 3 5.99999H7.99999C7.99999 4.67391 8.52677 3.40214 9.46445 2.46446C10.4021 1.52678 11.6739 1 13 1C14.3261 1 15.5978 1.52678 16.5355 2.46446C17.4732 3.40214 18 4.67391 18 5.99999H23C23.5304 5.99999 24.0391 6.21071 24.4142 6.58578C24.7893 6.96085 25 7.46956 25 7.99999V11",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5C13.0989 5 13.1956 5.02932 13.2778 5.08427C13.36 5.13921 13.4241 5.21729 13.4619 5.30866C13.4998 5.40002 13.5097 5.50055 13.4904 5.59754C13.4711 5.69453 13.4235 5.78363 13.3536 5.85355C13.2836 5.92348 13.1945 5.9711 13.0975 5.99039C13.0006 6.00968 12.9 5.99978 12.8087 5.96194C12.7173 5.92409 12.6392 5.86001 12.5843 5.77778C12.5293 5.69556 12.5 5.59889 12.5 5.5C12.5 5.36739 12.5527 5.24021 12.6464 5.14645C12.7402 5.05268 12.8674 5 13 5",
    stroke: "#DC2E33",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElektrabergzDetailsActive);
export default __webpack_public_path__ + "static/media/elektrabergz-details-active.49442a75a989a0c6f329281382075e23.svg";
export { ForwardRef as ReactComponent };